import { THEME_FONTS } from './types.ts';

export const FONTS: THEME_FONTS = {
  primary: 'Manrope',
  secondary: 'Lazydog',
};
